<template>
  <section class="settings-section">
    <header v-if="title || $slots.actions" class="settings-section__head">
      <div class="settings-section__titles">
        <h2 v-if="title" class="settings-section__title">{{ title }}</h2>
        <p v-if="description" class="settings-section__description">{{ description }}</p>
      </div>
      <div v-if="$slots.actions" class="settings-section__actions">
        <slot name="actions" />
      </div>
    </header>
    <slot />
  </section>
</template>
<script>
// A card of related settings with a title and a short intro of what they change.
export default {
  name: "SettingsSection",
  props: {
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss" scoped>
.settings-section {
  padding: 24px;
  border: 1px solid #eeeef3;
  border-radius: 16px;
  background: #fff;

  & + & {
    margin-top: 20px;
  }

  @media (max-width: 575px) {
    padding: 16px;
  }
}

.settings-section__head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px 24px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eeeef3;
}

.settings-section__titles {
  flex: 1 1 320px;
  min-width: 0;
}

.settings-section__title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
  color: #141414;
}

.settings-section__description {
  max-width: 720px;
  margin: 6px 0 0;
  font-size: 14px;
  line-height: 1.55;
  color: #5d5d6b;
}

.settings-section__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

body.dark {
  .settings-section {
    border-color: #343438;
    background: #262629;
  }

  .settings-section__head {
    border-bottom-color: #343438;
  }

  .settings-section__title {
    color: #dddddd;
  }

  .settings-section__description {
    color: #b7b7b7;
  }
}
</style>
